import React from 'react';
import { NewModal } from 'lib/components';
import { Button } from 'react-covideo-common';
import { Flex } from 'lib/components/styles/layout';
import { Formik, Form, FormikValues } from 'formik';
import { FormikInputField } from 'lib/components/formik/FormikInputField';
import * as Yup from 'yup';
import { useDeleteGroupsMutation } from 'lib/api/group/useDeleteGroupsMutation';
import { FormikCheckboxField } from 'lib/components/formik/FormikCheckbox';

type Props = {
  groupIds: number[];
  onModalClose: () => void;
  onSuccess?: () => void;
};

const modalDeleteSchema = Yup.object().shape({
  delete: Yup.string()
    .required('This field is required.')
    .oneOf(['DELETE'], 'You must type DELETE to confirm deletion.'),
});

export const ModalDeleteGroup = ({
  onModalClose,
  groupIds,
  onSuccess,
}: Props) => {
  const onSuccessHandler = () => {
    if (onSuccess) onSuccess();
    onModalClose();
  };
  const { mutateAsync: deleteGroups } =
    useDeleteGroupsMutation(onSuccessHandler);
  const onSubmitHandler = (values: FormikValues) => {
    deleteGroups({
      groupIds,
      deleteContacts: values.deleteContacts,
    });
  };

  const count = groupIds.length;
  const headerText = `Delete ${count} ${count === 1 ? 'group' : 'groups'} forever`;
  const checkboxLabelText = `Delete all contacts in ${count === 1 ? 'this' : 'these'} group${count === 1 ? '' : 's'}`;

  return (
    <NewModal closeModal={onModalClose} headerText={headerText}>
      <Formik
        initialValues={{ delete: '', groupIds, deleteContacts: false }}
        onSubmit={onSubmitHandler}
        validationSchema={modalDeleteSchema}
        validateOnMount
      >
        {({ handleSubmit, isValid, isSubmitting }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Flex alignItems='center' justifyContent='flex-end' gap='5px'>
                <FormikInputField
                  name='delete'
                  type='text'
                  label={`Type DELETE to confirm deletion`}
                  isRequired={false}
                  disabled={isSubmitting}
                  placeholder='DELETE'
                />

                <Flex justifyContent='flex-start' width='100%'>
                  <FormikCheckboxField
                    name='deleteContacts'
                    label={checkboxLabelText}
                  />
                </Flex>
              </Flex>
              <Flex
                margin='32px 0 0 0'
                gap='5px'
                flexDirection='row'
                justifyContent='flex-end'
              >
                <Button
                  variant='secondary'
                  text={'Keep it'}
                  onClick={onModalClose}
                  type='button'
                  disabled={isSubmitting}
                />
                <Button
                  variant='red'
                  text={'Delete'}
                  disabled={!isValid || isSubmitting}
                  type='submit'
                />
              </Flex>
            </Form>
          );
        }}
      </Formik>
    </NewModal>
  );
};
